import { useConfigStore } from "../Stores/Config";

// Built-in wording for the EU AI Act labels (shown only while the project's
// organisation enforces it, see Config.isEuAiActEnforced). Keyed by the
// 2-letter language code; a server-side staticTranslations value wins.
const AI_CHIP_LABELS: Record<string, string> = {
  en: "AI",
  de: "KI",
  fr: "IA",
  es: "IA",
  it: "IA",
  nl: "AI",
  pt: "IA",
};

const AI_ASSISTANT_LABELS: Record<string, string> = {
  en: "AI assistant",
  de: "KI-Assistent",
  fr: "Assistant IA",
  es: "Asistente de IA",
  it: "Assistente IA",
  nl: "AI-assistent",
  pt: "Assistente de IA",
};

const translateAiLabel = (key: string, defaults: Record<string, string>) => {
  const configStore = useConfigStore.getState();
  const fallback =
    defaults[configStore.getCurrentLanguage(true)] ?? defaults.en;
  const text = configStore.translateTextWithFallback(key, fallback);
  // A blank override must not remove the label.
  return text.trim().length > 0 ? text : fallback;
};

export const getAiChipLabel = () => translateAiLabel("aiChipLabel", AI_CHIP_LABELS);

export const getAiAssistantLabel = () =>
  translateAiLabel("aiAssistantLabel", AI_ASSISTANT_LABELS);
